import { instance as axios } from "@/services/axios";
import VueCookies from "vue-cookies";
import swal from "sweetalert";

export default {
  // news
  async Login(form) {
    try {
      var response = await axios.post(`/Login/login`, form);
      return response.data;
    } catch (error) {
      return error.response;
    }
  },
  async LoginAzure(form) {
    try {
      var response = await axios.post(`/Login/loginazure`, form);
      return response.data;
    } catch (error) {
      return error.response;
    }
  },
  async GetLoginAzureSetting() {
    try {
      var response = await axios.get(`/Setting/get_login_azure_setting`);
      return response.data;
    } catch (error) {
      return error.response;
    }
  },
  async GetNews(value) {
    try {
      var response = await axios.get(
        `/News?take=${value.take}&page=${value.page}`
      );
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async GetNewByID(id) {
    try {
      var response = await axios.get(`/News/${id}`);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async CreateNews(form) {
    try {
      var response = await axios.post(`/News/CreateNews`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async UpdatetNews(form) {
    try {
      var response = await axios.post(`/News/UpdatetNews`, form);

      return response.data;
    } catch (error) {
      console.log(error);
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async DeleteNews(id) {
    try {
      var response = await axios.delete(`/News/DeleteNews/${id}`);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async GetNewsType() {
    try {
      var response = await axios.get(`/News/GetType`);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async GetNotificationNews(id) {
    try {
      var response = await axios.get(`/Notification/GetNews/${id}`);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async UploadImage(form) {
    try {
      function detectMimeType(b64) {
        return b64.indexOf("image/png") != -1 ? 1 : 0;
      }
      let payload = {
        type: detectMimeType(form.Base64String),
        ...form,
      };
      var response = await axios.post(`/News/UploadImage`, payload);
      return response.data;
    } catch (error) {
      console.log(error);
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async UploadImageSize(form) {
    try {
      var response = await axios.post(`/News/UploadImageReturnSize`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  // Notification
  async GetNotificationPerPage(value) {
    try {
      var response = await axios.get(
        `/Notification?take=${value.take}&page=${value.page}`
      );
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async GetNotificationByID(id) {
    try {
      var response = await axios.get(`/Notification/${id}`);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async PushNotification(form) {
    try {
      var response = await axios.post(`/Notification/push_notification`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async CancelNotification(form) {
    try {
      var response = await axios.post(
        `/Notification/cancle_notification`,
        form
      );
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  //banner
  async GetBanner(form) {
    try {
      var response = await axios.post(`/Banner`, form);
      return response.data;
    } catch (error) {
      await IsSwalUnauthorized(error.response);
      return error.response;
    }
  },
  async GetBannerByID(id) {
    try {
      var response = await axios.get(`/Banner/${id}`);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async CreateBanner(form) {
    try {
      var response = await axios.post(`/Banner/CreateBanner`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async UpdateBanner(form) {
    try {
      var response = await axios.put(`/Banner/UpdateBanner`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async DeleteBanner(id) {
    try {
      var response = await axios.get(`/Banner/DeleteBanner/${id}`);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async GetRedirectType() {
    try {
      var response = await axios.get(`/Banner/GetRedirectType`);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async GetRedirect(form) {
    try {
      var response = await axios.post(`/Banner/GetRedirect`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  // product
  async SearchProduct(form) {
    try {
      var response = await axios.post(`/Product/search`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async GetProductByID(id) {
    try {
      var response = await axios.get(`/product/${id}`);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async DeleteProduct(id) {
    try {
      var response = await axios.delete(`/product/DeleteProduct/${id}`);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async CreateProduct(form) {
    try {
      var response = await axios.post(`/Product/CreateProduct`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async UpdatetProduct(form) {
    try {
      var response = await axios.put(`/Product/UpdatetProduct`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async GetSubCategory(form) {
    try {
      var response = await axios.post(`/Product/GetSubCategory`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async GetRelateCategory(form) {
    try {
      var response = await axios.post(`/Product/GetRelateCategory`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  // Sell Channel
  async SellChannel() {
    try {
      var response = await axios.get(`/SellChannel`);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  // category
  async GetAllCategory(form) {
    try {
      var response = await axios.get(
        `/Category/GetAllCategory?search=${form.search}&include_subcategory=${form.includeSubcategory}`
      );
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async GetCategoryByID(id) {
    try {
      var response = await axios.get(`/Category/${id}`);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async Subcategory(form) {
    try {
      var response = await axios.get(`/Category/Subcategory`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async CreateMainCategory(form) {
    try {
      var response = await axios.post(`/Category`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async CreateSubCategory(form) {
    try {
      var response = await axios.post(`/Category/CreateSubcategory`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async UpdateMainCategory(form) {
    try {
      var response = await axios.put(`/Category`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async UpdateSubCategory(form) {
    try {
      var response = await axios.put(`/Category/UpdateSubcategory`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async GetProductCategory(form) {
    try {
      var response = await axios.post(`/Category/Subcategory`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
};
